export const CHAIN_MAP = {
  '1': {
    name: 'Ethereum',
    logo: 'https://tp-statics.tokenpocket.pro/token/tokenpocket-1654746200716.png',
    tokenExplorerEn: 'https://etherscan.com/token/{account}',
    explorerEn: 'https://etherscan.com/address/{account}',
    hashExplorerEn: 'https://etherscan.com/tx/{hash}',
    tokenExplorer: 'https://www.oklink.com/eth/token/{account}?hmsr=tpwallet',
    explorer: 'https://www.oklink.com/eth/address/{account}?hmsr=tpwallet',
    hashExplorer: 'https://www.oklink.com/eth/tx/{hash}?hmsr=tpwallet',
    blockchain_id: '1',
    order: 1,
    chainId: '1',
    info: {
      "chainName": "Ethereum Mainnet",
      "chainId": "0x1",
      "nativeCurrency": {
        "name": "Ether",
        "symbol": "ETH",
        "decimals": 18
      },
      "rpcUrls": [
        "https://mainnet.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161",
        "wss://mainnet.infura.io/ws/v3/9aa3d95b3bc440fa88ea12eaa4456161",
        "https://api.mycryptoapi.com/eth",
        "https://cloudflare-eth.com"
      ],
      "blockExplorerUrls": ["https://etherscan.io"]
    }
  },
  '25': {
    name: 'Cronos',
    logo: require('../assets/cronos.png'),
    explorer: 'https://cronoscan.com/address/{account}',
    hashExplorer: 'https://cronoscan.com/tx/{hash}',
    chainId: '25',
    info: {
      "chainName": "Cronos Mainnet",
      "chainId": "0x19",
      "nativeCurrency": {
        "name": "CRO",
        "symbol": "CRO",
        "decimals": 18
      },
      "rpcUrls": [
        "https://cronos-rpc.elk.finance",
        "https://cronosrpc-1.xstaking.sg"
      ],
      "blockExplorerUrls": ["https://cronoscan.com"]
    },
  },
  '56': {
    name: 'BSC',
    logo: 'https://tp-statics.tokenpocket.pro/token/tokenpocket-1654745966943.png',
    tokenExplorerEn: 'https://bscscan.com/token/{account}',
    explorerEn: 'https://bscscan.com/address/{account}',
    hashExplorerEn: 'https://bscscan.com/tx/{hash}',
    tokenExplorer: 'https://bscscan.com/token/{account}',
    explorer: 'https://bscscan.com/address/{account}',
    hashExplorer: 'https://bscscan.com/tx/{hash}',
    blockchain_id: '12',
    order: 2,
    chainId: '56',
    info: {
      "chainName": "Binance Smart Chain Mainnet",
      "chainId": '0x38',
      "nativeCurrency": {
        "name": "Binance Chain Native Token",
        "symbol": "BNB",
        "decimals": 18
      },
      "rpcUrls": [
        "https://bsc-dataseed1.binance.org",
        "https://bsc-dataseed2.binance.org",
        "https://bsc-dataseed3.binance.org",
        "https://bsc-dataseed4.binance.org",
        "https://bsc-dataseed1.defibit.io",
        "https://bsc-dataseed2.defibit.io",
        "https://bsc-dataseed3.defibit.io",
        "https://bsc-dataseed4.defibit.io",
        "https://bsc-dataseed1.ninicoin.io",
        "https://bsc-dataseed2.ninicoin.io",
        "https://bsc-dataseed3.ninicoin.io",
        "https://bsc-dataseed4.ninicoin.io",
        "wss://bsc-ws-node.nariox.org"
      ],
      "blockExplorerUrls": ["https://bscscan.com/"]
    },
  },
  '66': {
    name: 'OKTC',
    chainShortName: 'OKTC',
    logo: 'https://tp-statics.tokenpocket.pro/token/tokenpocket-1654745877453.png',
    tokenExplorer: 'https://www.oklink.com/oktc/token/{account}?hmsr=tpwallet',
    explorer: 'https://www.oklink.com/oktc/address/{account}?hmsr=tpwallet',
    hashExplorer: 'https://www.oklink.com/oktc/tx/{hash}?hmsr=tpwallet',
    blockchain_id: '20',
    order: 6,
    chainId: '66',
    info: {
      "chainName": "OKExChain Mainnet",
      "chainId": "0x42",
      "nativeCurrency": {
        "name": "OKExChain Global Utility Token",
        "symbol": "OKT",
        "decimals": 18
      },
      "rpcUrls": [
        "https://exchainrpc.okex.org"
      ],
      "blockExplorerUrls": ["https://www.oklink.com/en/okc"]
    },
  },
  '128': {
    name: 'HECO',
    logo: 'https://tp-statics.tokenpocket.pro/token/tokenpocket-1654745945767.png',
    explorer: 'https://hecoinfo.com/address/{account}',
    hashExplorer: 'https://hecoinfo.com/tx/{hash}',
    blockchain_id: '15',
    chainId: '128',
    info: {
      "chainName": "Huobi ECO Chain Mainnet",
      "chainId": "0x80",
      "nativeCurrency": {
        "name": "Huobi ECO Chain Native Token",
        "symbol": "HT",
        "decimals": 18
      },
      "rpcUrls": [
        "https://http-mainnet.hecochain.com",
        "wss://ws-mainnet.hecochain.com"
      ],
      "blockExplorerUrls": ["https://www.hecochain.com"]
    },
  },
  '137': {
    name: 'Polygon',
    chainShortName: 'POLYGON',
    logo: 'https://tp-statics.tokenpocket.pro/token/tokenpocket-1654746268728.png',
    tokenExplorer: 'https://www.oklink.com/polygon/token/{account}?hmsr=tpwallet',
    explorer: 'https://www.oklink.com/polygon/address/{account}?hmsr=tpwallet',
    hashExplorer: 'https://www.oklink.com/polygon/tx/{hash}?hmsr=tpwallet',
    blockchain_id: '18',
    order: 5,
    chainId: '137',
    info: {
      "chainName": "Polygon LlamaNodes",
      "chainId": "0x89",
      "nativeCurrency": {
        "name": "Matic",
        "symbol": "MATIC",
        "decimals": 18
      },
      "rpcUrls": [
        "https://polygon.llamarpc.com",
        "wss://ws-mainnet.matic.network"
      ],
      "blockExplorerUrls": ["https://polygonscan.com"]
    },
  },
  '250': {
    name: 'Fantom',
    chainShortName: 'FTM',
    logo: 'https://tp-statics.tokenpocket.pro/token/tokenpocket-1654745790639.png',
    tokenExplorer: 'https://www.oklink.com/ftm/token/{account}?hmsr=tpwallet',
    explorer: 'https://www.oklink.com/ftm/address/{account}?hmsr=tpwallet',
    hashExplorer: 'https://www.oklink.com/ftm/tx/{hash}?hmsr=tpwallet',
    blockchain_id: '25',
    order: 7,
    chainId: '250',
    info: {
      "chainName": "Fantom Opera",
      "chainId": "0xfa",
      "nativeCurrency": {
        "name": "Fantom",
        "symbol": "FTM",
        "decimals": 18
      },
      "rpcUrls": [
        "https://rpcapi.fantom.network",
        "https://fantomscan.io/rpc"
      ],
      "blockExplorerUrls": ["https://ftmscan.com"]
    },
  },
  '321': {
    name: 'KCC',
    logo: 'https://tp-statics.tokenpocket.pro/token/tokenpocket-1654745855918.png',
    explorer: 'https://explorer.kcc.io/address/{account}',
    hashExplorer: 'https://explorer.kcc.io/tx/{hash}',
    blockchain_id: '35',
    chainId: '321',
    info: {
      "chainName": "KCC Mainnet",
      "chainId": "0x141",
      "nativeCurrency": {
        "name": "KuCoin Token",
        "symbol": "KCS",
        "decimals": 18
      },
      "rpcUrls": [
        "https://rpc-mainnet.kcc.network",
        "wss://rpc-ws-mainnet.kcc.network"
      ],
      "blockExplorerUrls": ["https://explorer.kcc.io/en"]
    },
  },
  '42161': {
    name: 'Arbitrum',
    chainShortName: 'ARBITRUM',
    logo: 'https://tp-statics.tokenpocket.pro/token/tokenpocket-1654746255647.png',
    tokenExplorer: 'https://www.oklink.com/arbitrum/token/{account}?hmsr=tpwallet',
    explorer: 'https://www.oklink.com/arbitrum/address/{account}?hmsr=tpwallet',
    hashExplorer: 'https://www.oklink.com/arbitrum/tx/{hash}?hmsr=tpwallet',
    blockchain_id: '24',
    order: 4,
    chainId: '42161',
    info: {
      "chainName": "Arbitrum One",
      "chainId": "0xa4b1",
      "nativeCurrency": {
        "name": "ETH",
        "symbol": "ETH",
        "decimals": 18
      },
      "rpcUrls": [
        "https://arb1.arbitrum.io/rpc"
      ],
      "blockExplorerUrls": ["https://arbiscan.io"]
    },
  },
  '43114': {
    name: 'Avalanche',
    chainShortName: 'AVAXC',
    logo: 'https://tp-statics.tokenpocket.pro/token/tokenpocket-1654746242698.png',
    tokenExplorer: 'https://www.oklink.com/avax/token/{account}?hmsr=tpwallet',
    explorer: 'https://www.oklink.com/avax/address/{account}?hmsr=tpwallet',
    hashExplorer: 'https://www.oklink.com/avax/tx/{hash}?hmsr=tpwallet',
    blockchain_id: '23',
    order: 8,
    chainId: '43114',
    info: {
      "chainName": "Avalanche Mainnet",
      "chainId": "0xa86a",
      "nativeCurrency": {
        "name": "Avalanche",
        "symbol": "AVAX",
        "decimals": 18
      },
      "rpcUrls": [
        "https://api.avax.network/ext/bc/C/rpc"
      ],
      "blockExplorerUrls": ["https://snowtrace.io"]
    },
  },
  '1666600000': {
    name: 'Harmony',
    logo: 'https://tp-statics.tokenpocket.pro/token/tokenpocket-1654746161254.png',
    explorer: 'https://explorer.harmony.one/address/{account}',
    hashExplorer: 'https://explorer.harmony.one/tx/{hash}',
    blockchain_id: '33',
    chainId: '1666600000',
    info: {
      "chainName": "Harmony Mainnet Shard 0",
      "chainId": "0x63564c40",
      "nativeCurrency": {
        "name": "ONE",
        "symbol": "ONE",
        "decimals": 18
      },
      "rpcUrls": [
        "https://rpc.s0.t.hmny.io"
      ],
      "blockExplorerUrls": ["https://explorer.harmony.one"]
    }
  },
  '728126428': {
    name: 'Tron',
    logo: 'https://tp-statics.tokenpocket.pro/token/tokenpocket-1654746014796.png',
    explorer: 'https://tronscan.io/#/address/{account}',
    hashExplorer: 'https://tronscan.io/#/transaction/{hash}',
    blockchain_id: '10',
    order: 3,
    chainId: '728126428',
  }
}

export const TOKEN_ABI = [{ "constant": true, "inputs": [], "name": "name", "outputs": [{ "name": "", "type": "string" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "name": "_spender", "type": "address" }, { "name": "_value", "type": "uint256" }], "name": "approve", "outputs": [{ "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "totalSupply", "outputs": [{ "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "name": "_from", "type": "address" }, { "name": "_to", "type": "address" }, { "name": "_value", "type": "uint256" }], "name": "transferFrom", "outputs": [{ "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "decimals", "outputs": [{ "name": "", "type": "uint8" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [{ "name": "_owner", "type": "address" }], "name": "balanceOf", "outputs": [{ "name": "balance", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "symbol", "outputs": [{ "name": "", "type": "string" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "name": "_to", "type": "address" }, { "name": "_value", "type": "uint256" }], "name": "transfer", "outputs": [{ "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [{ "name": "_owner", "type": "address" }, { "name": "_spender", "type": "address" }], "name": "allowance", "outputs": [{ "name": "remaining", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "inputs": [], "payable": false, "stateMutability": "nonpayable", "type": "constructor" }, { "anonymous": false, "inputs": [{ "indexed": true, "name": "from", "type": "address" }, { "indexed": true, "name": "to", "type": "address" }, { "indexed": false, "name": "value", "type": "uint256" }], "name": "Transfer", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "name": "owner", "type": "address" }, { "indexed": true, "name": "spender", "type": "address" }, { "indexed": false, "name": "value", "type": "uint256" }], "name": "Approval", "type": "event" }];

export const NFT_ABI = [{"inputs":[{"internalType":"string","name":"_name","type":"string"},{"internalType":"string","name":"_symbol","type":"string"}],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"approved","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"operator","type":"address"},{"indexed":false,"internalType":"bool","name":"approved","type":"bool"}],"name":"ApprovalForAll","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"account","type":"address"}],"name":"MinterAdded","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"account","type":"address"}],"name":"MinterRemoved","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"Transfer","type":"event"},{"payable":false,"stateMutability":"nonpayable","type":"fallback"},{"constant":false,"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"addMinter","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"approve","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address[]","name":"_to","type":"address[]"},{"internalType":"uint256","name":"_tokenId","type":"uint256"}],"name":"batchAddrMint","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"_to","type":"address"},{"internalType":"uint256[]","name":"_tokenId","type":"uint256[]"}],"name":"batchMint","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[],"name":"claim","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[],"name":"draw","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"getApproved","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"gettid","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"operator","type":"address"}],"name":"isApprovedForAll","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"isMinter","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"isOwner","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"mint","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"ownerOf","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[],"name":"renounceMinter","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[],"name":"renounceOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"uint256","name":"_newtid","type":"uint256"}],"name":"reset","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"safeTransferFrom","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"bytes","name":"_data","type":"bytes"}],"name":"safeTransferFrom","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"bool","name":"approved","type":"bool"}],"name":"setApprovalForAll","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"internalType":"bytes4","name":"interfaceId","type":"bytes4"}],"name":"supportsInterface","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"uint256","name":"index","type":"uint256"}],"name":"tokenByIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"uint256","name":"index","type":"uint256"}],"name":"tokenOfOwnerByIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"tokenURI","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"_to","type":"address"},{"internalType":"uint256","name":"_tokenId","type":"uint256"}],"name":"transfer","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"_to","type":"address"},{"internalType":"uint256[]","name":"_tokenId","type":"uint256[]"}],"name":"transferAll","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"transferFrom","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"}]